import {COUNTRIES} from '../../actions/countries/countriesActionTypes';

const INITIAL_STATE = {
  countriesLoading: true,
  citiesLoading: true,
  countries: [],
  cities: []
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case COUNTRIES.GET_COUNTRIES_SUCCESS:
      return {...state, countries: action.payload.data.data, countriesLoading: false};
    case COUNTRIES.GET_CITIES_SUCCESS:
      return {...state, cities: action.payload.data.data, citiesLoading: false};
    case COUNTRIES.GET_CITIES_FAIL:
      return {...state, cities: [], citiesLoading: false};
    default:
      return state;
  }
}
